var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWalletIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7578_2842)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 5.83333H17.5C17.721 5.83333 17.933 5.92113 18.0892 6.07741C18.2455 6.23369 18.3333 6.44565 18.3333 6.66667V16.6667C18.3333 16.8877 18.2455 17.0996 18.0892 17.2559C17.933 17.4122 17.721 17.5 17.5 17.5H2.49999C2.27898 17.5 2.06701 17.4122 1.91073 17.2559C1.75445 17.0996 1.66666 16.8877 1.66666 16.6667V3.33333C1.66666 3.11232 1.75445 2.90036 1.91073 2.74408C2.06701 2.5878 2.27898 2.5 2.49999 2.5H15V5.83333ZM3.33332 7.5V15.8333H16.6667V7.5H3.33332ZM3.33332 4.16667V5.83333H13.3333V4.16667H3.33332ZM12.5 10.8333H15V12.5H12.5V10.8333Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7578_2842"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletIcon);
export default __webpack_public_path__ + "static/media/WalletIcon.d52b8ac2ce0abf0ebcb757cebd562805.svg";
export { ForwardRef as ReactComponent };